import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-left', 'ChevronLeft', [["path",{"d":"M15 6l-6 6l6 6"}]]);